/*LIBRARY*/
import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import io from "socket.io-client";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import IMPORT_LAYER_VIA_SEARCH from "./IMPORT_LAYER_VIA_SEARCH";

/*REDUX*/
import { getDetailLayerById } from "../../App/actions/get_features_action";
import { set_value_properties } from "../../App/actions/propertiesActions";
import { get_pda, get_pch } from "../../App/actions/iotActions";
import { get_layer_detail_custom_api } from "../../App/actions/openApiActions";
import { view_layer, set_layer_id } from "../../App/actions/dataActions";
import {
  setTabelStatus,
  setEditGeometry,
  set_value_layer,
} from "../../App/actions/layerActions";
import { getProjectList } from "../../App/actions/projectActions";
import { set_value_toolbox } from "../../App/actions/toolboxActions";

/*PICTURE*/
import ICON_VIEW from "../../Assets/jsx/ICON_VIEW";
import ICON_TABLE from "../../Assets/jsx/ICON_TABLE";
import ICON_GEOMETRY from "../../Assets/jsx/ICON_GEOMETRY";
import icon_search from "../../Assets/svg/icon_search.svg";
import icon_import from "../../Assets/svg/icon_import.svg";

/*FUNCTION*/
import getStatusMember from "../../App/validation/get-status-member";

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/
const SOCKET_URL_MAPID = "https://socket.mapid.io";
const geo_layer_status_that_editable_properties = [
  "original",
  "digitasi",
  "upload",
  "site_selection",
  "SS_MANUAL",
];

const SEARCH_LAYER = ({
  auth,
  layer,
  project,
  properties,
  getDetailLayerById,
  set_value_properties,
  get_pda,
  get_pch,
  get_layer_detail_custom_api,
  view_layer,
  set_layer_id,
  setTabelStatus,
  setEditGeometry,
  getProjectList,
  set_value_layer,
  set_value_toolbox,
  on_deactivate_input_status,
}) => {
  const [modal_import, set_modal_import] = useState(false);
  const socketRef = useRef(null);

  useEffect(() => {
    socketRef.current = io.connect(SOCKET_URL_MAPID, {
      secure: true,
      reconnection: true,
      rejectUnauthorized: false,
    });

    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
      }
    };
  }, []);

  const getRandomColor = () => {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  const handle_subscribe_socket = (user, layerId) => {
    if (socketRef.current) {
      socketRef.current.emit("from_mapid_backend", {
        data: { ...user, idLayer: layerId, borderColor: getRandomColor() },
        topic: "userUpdate",
      });
    }
  };

  const handle_pre_subscribe_socket = (dataId) => {
    const { _id, name, full_name, email, profile_picture } = auth?.user || {};
    const user_data = {
      _id,
      name,
      full_name,
      email,
      profile_picture,
    };
    handle_subscribe_socket(user_data, dataId);
  };

  const on_search_inside = (geo_layer_id, geo_layer_name) => {
    set_value_properties({
      key: "mode_search",
      value: "search_inside",
    });
    set_value_properties({
      key: "layer_id_search_inside",
      value: geo_layer_id,
    });
    set_value_properties({
      key: "layer_name_search_inside",
      value: geo_layer_name,
    });
  };

  const toggle_import = (geo_layer_id) => {
    set_modal_import((prev_modal_import) => {
      const next_modal_import = !prev_modal_import;
      if (next_modal_import) {
        if (auth?.isAuthenticated) {
          getProjectList();
        }
        if (typeof geo_layer_id === "string") {
          set_layer_id(geo_layer_id);
        }
      }
      return next_modal_import;
    });
  };

  const on_view_layer = (geo_layer_item, value, folder_id) => {
    if (on_deactivate_input_status) {
      on_deactivate_input_status();
    }
    //layer yang saat ini sedang aktif (layer yang diklik bisa jadi sama, bisa jadi beda)
    const { layer_id } = layer;
    if (
      (layer_id !== geo_layer_item?._id &&
        geo_layer_item?.geojson?.features?.length === 0) ||
      !geo_layer_item?.geojson?.features
    ) {
      //kemungkinan 1: belum ada geojson, ambil geojson dulu, kemudian aktifkan view
      if (geo_layer_item?.type_2 === "pch") {
        get_pch(geo_layer_item);
      } else if (geo_layer_item?.type_2 === "pda") {
        get_pda(geo_layer_item);
      } else {
        if (geo_layer_item?.is_custom_endpoint) {
          get_layer_detail_custom_api(geo_layer_item._id);
        } else {
          const { geo_project } = project;
          const body = {
            geo_layer_id: geo_layer_item._id,
            geo_project_id: geo_project._id,
            folder_id: folder_id,
            capex_value: properties.capex_value,
            geo_layer_item,
          };
          getDetailLayerById(body);
        }
      }
    } else {
      //kemungkinan 2: sudah ada geojson, langsung toggle view
      const body = { geo_layer_id: geo_layer_item._id, value };
      view_layer(body);
    }
  };

  const toggle_edit_geometry = (geo_layer_item, folder_id) => {
    if (on_deactivate_input_status) {
      on_deactivate_input_status();
    }
    const {
      geometryStatus,
      layer_id,
      map_object,
      layer_id_bound,
      draw_object,
    } = layer;
    const { geo_project } = project;

    if (!geometryStatus) {
      //tidak aktif ke AKTIF
      const { type, architecture } = geo_layer_item;
      set_value_layer({
        key: "current_architecture",
        value: architecture,
      });
      set_value_layer({
        key: "current_type",
        value: type,
      });
      set_value_toolbox({
        key: "mode_draw",
        value: "simple_select",
      });
      handle_pre_subscribe_socket(geo_layer_item._id);
      set_value_layer({
        key: "draw_state_platform",
        value: "geometry",
      });
      const geojson = geo_layer_item?.geojson || {
        type: "FeatureCollection",
        features: [],
      };

      if (draw_object) {
        draw_object.add(geojson);
        draw_object.changeMode("simple_select");
      }

      if (map_object?.getCanvas()?.style?.cursor) {
        map_object.getCanvas().style.cursor = ""; //reset cursor
      }
    } else {
      //aktif ke TIDAK AKTIF
      set_value_layer({
        key: "draw_state_platform",
        value: "",
      });
      if (map_object?.getCanvas()?.style?.cursor) {
        map_object.getCanvas().style.cursor = ""; //reset cursor
      }

      if (draw_object) {
        draw_object?.changeMode("simple_select"); //deactivate draw mode
        draw_object?.deleteAll();
      }
    }

    if (geo_layer_item?.is_use_bounding_box) {
      if (!layer_id_bound.includes(geo_layer_item?._id)) {
        const body = { geo_layer_id: geo_layer_item._id, value: true };
        view_layer(body);
        const new_layer_id_bound = [...layer_id_bound, geo_layer_item?._id];
        set_value_layer({
          key: "layer_id_bound",
          value: new_layer_id_bound,
        });
      }
    } else {
      if (layer_id !== geo_layer_item._id) {
        if (!geo_layer_item?.geojson?.features?.length) {
          if (geo_layer_item?.type_2 === "pch") {
            get_pch(geo_layer_item);
          } else if (geo_layer_item?.type_2 === "pda") {
            get_pda(geo_layer_item);
          } else {
            if (geo_layer_item?.is_custom_endpoint) {
              get_layer_detail_custom_api(geo_layer_item._id);
            } else {
              const body = {
                geo_layer_id: geo_layer_item._id,
                geo_project_id: geo_project._id,
                folder_id: folder_id,
                capex_value: properties.capex_value,
                geometryStatus: !geometryStatus,
                geo_layer_item,
              };
              getDetailLayerById(body);
            }
          }
          handle_pre_subscribe_socket(geo_layer_item._id);
        } else {
          set_layer_id(geo_layer_item._id);
          setEditGeometry(!geometryStatus);
        }
      } else {
        if (!geo_layer_item?.geojson?.features?.length) {
          const body = {
            geo_layer_id: geo_layer_item._id,
            geo_project_id: geo_project._id,
            folder_id,
            capex_value: properties.capex_value,
            geometryStatus: !geometryStatus,
            geo_layer_item,
          };
          getDetailLayerById(body);
          handle_pre_subscribe_socket(geo_layer_item._id);
        } else {
          set_layer_id(geo_layer_item._id);
          setEditGeometry(!geometryStatus);
        }
      }
    }
  };

  const toggle_edit_property = (geo_layer_item, folder_id) => {
    if (on_deactivate_input_status) {
      on_deactivate_input_status();
    }
    const { tableStatus, layer_id } = layer;
    const { geo_project } = project;
    //Jika layer yang diklik bukanlah layer yang sedang aktif--> aktifkan layer
    if (layer_id !== geo_layer_item._id) {
      //Jika layer belum memiliki geojson, ambil geojson via API
      if (
        geo_layer_item?.geojson?.features?.length === 0 ||
        !geo_layer_item?.geojson?.features
      ) {
        setTabelStatus(true);
        //kemungkinan 1: belum ada geojson, ambil geojson dulu, kemudian aktifkan view
        if (geo_layer_item?.type_2 === "pch") {
          get_pch(geo_layer_item);
        } else if (geo_layer_item?.type_2 === "pda") {
          get_pda(geo_layer_item);
        } else {
          if (geo_layer_item?.is_custom_endpoint) {
            get_layer_detail_custom_api(geo_layer_item._id);
          } else {
            const body = {
              geo_layer_id: geo_layer_item._id,
              geo_project_id: geo_project._id,
              folder_id,
              capex_value: properties.capex_value,
              tableStatus: true,
              geo_layer_item,
            };
            getDetailLayerById(body);
          }
        }
      } else {
        //Jika layer sudah memiliki geojson --> aktifkan layer tanpa mengambil geojson lagi
        set_layer_id(geo_layer_item._id);
        setTabelStatus(true);
      }
    } else {
      //Jika layer yang diklik adalah layer yang sedang aktif
      //Jika layer awalnya kosong, coba cek ke API lagi, barangkali sekarang ada isinya
      if (
        geo_layer_item?.geojson?.features?.length === 0 ||
        !geo_layer_item?.geojson?.features
      ) {
        setTabelStatus(!tableStatus);
        if (geo_layer_item?.type_2 === "pch") {
          get_pch(geo_layer_item);
        } else if (geo_layer_item?.type_2 === "pda") {
          get_pda(geo_layer_item);
        } else {
          if (geo_layer_item?.is_custom_endpoint) {
            get_layer_detail_custom_api(geo_layer_item._id);
          } else {
            const body = {
              geo_layer_id: geo_layer_item._id,
              geo_project_id: geo_project._id,
              folder_id,
              capex_value: properties.capex_value,
              tableStatus: !tableStatus,
              geo_layer_item,
            };
            getDetailLayerById(body);
          }
        }
      } else {
        set_layer_id(geo_layer_item._id);
        setTabelStatus(!tableStatus);
      }
    }
  };

  //local storage
  const language = localStorage?.language || auth.language;

  //global props
  const { layer_id_filtered, search_input, shared_link_check } = properties;
  const {
    tableStatus,
    geo_layer_list,
    layer_id,
    layer_id_active,
    geometryStatus,
    geo_layer_wo_geojson,
    chatStatus,
  } = layer;
  const { isAuthenticated, user } = auth;
  const { geo_project } = project;

  //content
  const is_project_public = geo_project?.isPublic;

  const role = shared_link_check?.role;
  let is_author = false;
  if (isAuthenticated) {
    let userCurrentStatus;
    const groups = geo_project?.groups || [];
    if (geo_project?._id) {
      userCurrentStatus = getStatusMember(groups, user?._id);
    }
    is_author = !!userCurrentStatus || !!(geo_project?.user?._id === user?._id);
  }

  let layer_final;

  if (!search_input) {
    layer_final = geo_layer_list;
  } else {
    layer_final = geo_layer_list.filter((item) =>
      layer_id_filtered.includes(item?.geo_layer?._id),
    );
  }

  const content = (
    <section
      style={{
        overflowY: "auto",
        height: "500px",
        maxHeight: "calc((100vh - 300px))",
        marginTop: "20px",
      }}
    >
      {layer_final.map((layer_item, idx) => {
        const geo_layer = layer_item?.geo_layer ? layer_item.geo_layer : {};
        const folder_id = layer_item?.folder || "";
        const status = layer_item?.status;
        const { _id, name, description, architecture } = geo_layer;
        const viewStatus = layer_id_active.includes(geo_layer?._id);
        return (
          <main
            key={idx}
            className="container_light button_white margin_bottom outline_grey"
          >
            <p className="text_bold margin_bottom">{name}</p>
            {!!description && (
              <p className="text_small max_two_lines">{description}</p>
            )}

            <section className="layer_action_section">
              <div
                className="cursor_pointer layer_action_item"
                onClick={() => on_view_layer(geo_layer, !viewStatus, folder_id)}
                data-mapid={`clickTutupMata-${idx}`}
              >
                <ICON_VIEW
                  color={viewStatus ? "#000" : "#696969"}
                  strokeWidth={viewStatus ? 4 : 3}
                  style={{ width: "27px", height: "27px" }}
                />
                <p
                  className={`layer_action_label ${
                    viewStatus ? "active_label" : "inactive_label"
                  }`}
                >
                  {dict?.["View"]?.[language]}
                </p>
              </div>

              {(is_author || role === "viewer_download" || role === "editor") &&
                geo_layer_status_that_editable_properties.includes(status) &&
                architecture !== "api" && (
                  <div
                    className="cursor_pointer layer_action_item"
                    onClick={() => toggle_edit_geometry(geo_layer, folder_id)}
                    data-mapid={`clickBukaDigitasi-${idx}`}
                  >
                    <ICON_GEOMETRY
                      color={
                        _id === layer_id && geometryStatus ? "#000" : "#696969"
                      }
                      strokeWidth={_id === layer_id && geometryStatus ? 4 : 3}
                      style={{ width: "27px", height: "27px" }}
                    />
                    <p
                      className={`layer_action_label ${
                        _id === layer_id && geometryStatus
                          ? "active_label"
                          : "inactive_label"
                      }`}
                    >
                      {dict?.["Geometry"]?.[language]}
                    </p>
                  </div>
                )}

              <div
                className="cursor_pointer layer_action_item"
                onClick={() => toggle_edit_property(geo_layer, folder_id)}
                data-mapid={`clickBukaTable-${idx}`}
              >
                <ICON_TABLE
                  color={_id === layer_id && tableStatus ? "#000" : "#696969"}
                  strokeWidth={_id === layer_id && tableStatus ? 4 : 3}
                  style={{ width: "27px", height: "27px" }}
                />
                <p
                  className={`layer_action_label ${
                    _id === layer_id && tableStatus
                      ? "active_label"
                      : "inactive_label"
                  }`}
                >
                  {dict?.["Table"]?.[language]}
                </p>
              </div>

              {(is_author ||
                role === "viewer_download" ||
                role === "editor" ||
                is_project_public) && (
                <div
                  className="cursor_pointer layer_action_item"
                  onClick={() => on_search_inside(_id, name)}
                >
                  <img
                    src={icon_search}
                    alt={dict["Search"][language]}
                    height="27px"
                    style={{ margin: "auto" }}
                  />
                  <p
                    className={`layer_action_label ${
                      _id === geo_layer_wo_geojson?.geo_layer?._id && chatStatus
                        ? "active_label"
                        : "inactive_label"
                    }`}
                  >
                    {dict["Search"][language]}
                  </p>
                </div>
              )}

              {(is_author ||
                role === "viewer_download" ||
                role === "editor" ||
                is_project_public) && (
                <div
                  className="cursor_pointer layer_action_item"
                  onClick={() => toggle_import(geo_layer?._id)}
                >
                  <img
                    src={icon_import}
                    alt={dict["Import"][language]}
                    height="27px"
                    style={{ margin: "auto" }}
                  />
                  <p
                    className={`layer_action_label ${
                      _id === geo_layer_wo_geojson?.geo_layer?._id && chatStatus
                        ? "active_label"
                        : "inactive_label"
                    }`}
                  >
                    {dict["Import"][language]}
                  </p>
                </div>
              )}
            </section>
          </main>
        );
      })}
    </section>
  );

  const modal_import_content = modal_import && (
    <Modal
      modalSize="large"
      isOpen={modal_import}
      onClose={() => toggle_import()}
    >
      <div className="box-body" id="box-body">
        <IMPORT_LAYER_VIA_SEARCH />
      </div>
    </Modal>
  );

  return (
    <main>
      {modal_import_content}
      {!search_input && (
        <p className="text_medium sub_color margin_bottom">
          {
            dict?.[
              "Search for layers in this project by typing their names or descriptions as keywords"
            ]?.[language]
          }
        </p>
      )}
      {!search_input && layer_id_filtered.length === 0 && (
        <section>
          <span className="button_pill_small background_black margin_right inline">
            {geo_layer_list.length}
          </span>
          <p className="text_medium inline">{dict?.["Layers"]?.[language]}</p>
        </section>
      )}
      {layer_id_filtered.length === 0 && !!search_input && (
        <p className="text_medium">{dict?.["No result"]?.[language]}</p>
      )}
      {layer_id_filtered.length > 0 && (
        <section>
          <span className="button_pill_small background_black margin_right inline">
            {layer_id_filtered.length}
          </span>
          <p className="text_medium inline">{dict?.["Result"]?.[language]}</p>
        </section>
      )}
      {content}
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  project: state.project,
  properties: state.properties,
});

export default connect(mapStateToProps, {
  getDetailLayerById,
  set_value_properties,
  get_pda,
  get_pch,
  get_layer_detail_custom_api,
  view_layer,
  set_layer_id,
  setTabelStatus,
  setEditGeometry,
  getProjectList,
  set_value_layer,
  set_value_toolbox,
})(SEARCH_LAYER);
